import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import 'vue-color/style.css';
import VTooltip from 'v-tooltip'


const tooltipOptions = {
  distance: 12,
  themes: {
    tooltip: {
      delay: {
        show: 500,
        hide: 0
      }
    }
  }
}

const app = createApp(App);
app.use(router);
app.use(VTooltip);
app.use(FloatingVue, tooltipOptions);
// app.use(VoIPPlugin)
app.mount('#app');
